import React from 'react';
import { Loader2 } from 'lucide-react';

interface InquiryFormProps {
  message: string;
  onMessageChange: (message: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  loading: boolean;
}

export const InquiryForm: React.FC<InquiryFormProps> = ({
  message,
  onMessageChange,
  onSubmit,
  onCancel,
  loading,
}) => {
  const templateMessages = [
    "We're interested in scheduling a viewing. When would be a good time?",
    "Is this property still available? We'd love to learn more about it.",
    "Could we schedule a viewing this week? We're very interested in this property.",
  ];

  const handleTemplateClick = (template: string) => {
    onMessageChange(template);
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <label htmlFor="inquiry-message" className="block text-sm font-semibold text-text-primary mb-2">
        Message to landlord (optional)
      </label>
      
      {/* Template buttons - only show when message is empty */}
      {!message && (
        <div className="mb-3 space-y-2">
          <p className="text-xs text-text-secondary mb-1.5">Quick templates:</p>
          {templateMessages.map((template, index) => (
            <button
              key={index}
              onClick={() => handleTemplateClick(template)}
              className="w-full text-left px-3 py-2 bg-white border border-gray-200 rounded-lg text-xs text-text-secondary hover:border-primary-200 hover:bg-primary-50 hover:text-primary-300 transition-colors"
            >
              {template}
            </button>
          ))}
        </div>
      )}

      <textarea
        id="inquiry-message"
        className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-primary-200 focus:outline-none mb-3 text-sm resize-none"
        rows={3}
        placeholder="Tell the landlord about yourselves..."
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
      />
      <div className="flex gap-2">
        <button
          onClick={onSubmit}
          disabled={loading}
          className="flex-1 flex items-center justify-center gap-2 bg-primary-300 text-white py-2 rounded-lg font-semibold hover:bg-primary-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          {loading ? 'Sending...' : 'Send Inquiry'}
        </button>
        <button
          onClick={onCancel}
          disabled={loading}
          className="px-4 bg-gray-200 text-text-primary py-2 rounded-lg font-semibold hover:bg-gray-300 transition-colors disabled:opacity-50"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
